document.addEventListener('DOMContentLoaded', function() {
  // Définir un observateur pour les animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  });

  // Observer tous les éléments motion-element
  document.querySelectorAll('motion-element').forEach(element => {
    observer.observe(element);
  });
});